import { useParams, Navigate } from 'react-router-dom'
import { Check, ArrowRight, Shield } from 'lucide-react'
import Navbar from '../components/landing/Navbar'
import Footer from '../components/landing/Footer'
import { USE_CASES } from '../data/useCases'

export default function UseCasePage() {
    const { slug } = useParams()
    const data = USE_CASES[slug]

    if (!data) {
        return <Navigate to="/" replace />
    }

    return (
        <div className="min-h-screen bg-slate-950">
            <Navbar />

            <main>
                {/* Hero Section */}
                <div className="pt-32 pb-16 px-4">
                    <div className="max-w-7xl mx-auto text-center">
                        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-sm font-medium mb-6">
                            <Shield className="w-3 h-3" />
                            <span>{data.title}</span>
                        </div>
                        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 bg-clip-text text-transparent bg-gradient-to-r from-white via-indigo-100 to-indigo-200">
                            {data.heroTitle}
                        </h1>
                        <p className="text-xl text-slate-400 max-w-2xl mx-auto mb-10">
                            {data.description}
                        </p>
                        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                            <button className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-medium rounded-xl transition-all shadow-lg shadow-indigo-500/20 flex items-center justify-center gap-2">
                                Start Free Trial <ArrowRight className="w-4 h-4 ml-1" />
                            </button>
                            <button className="w-full sm:w-auto px-8 py-3 bg-white/5 hover:bg-white/10 text-white font-medium rounded-xl transition-all">
                                View Demo
                            </button>
                        </div>
                    </div>
                </div>

                {/* Comparison/Features Grid */}
                <div className="py-20 bg-slate-900/50 border-y border-white/5">
                    <div className="max-w-7xl mx-auto px-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                            <div>
                                <h3 className="text-2xl font-bold text-white mb-6">Why switch?</h3>
                                <div className="space-y-4">
                                    {data.features.map((feature, i) => (
                                        <div key={i} className="flex items-center gap-3">
                                            <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
                                                <Check className="w-3 h-3 text-green-400" />
                                            </div>
                                            <span className="text-slate-300 font-medium">{feature}</span>
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-8 p-6 bg-slate-800 rounded-xl border border-white/5">
                                    <h4 className="text-sm font-semibold text-indigo-400 mb-2 uppercase tracking-wider">The InkSpot Advantage</h4>
                                    <p className="text-xl text-white font-medium">"{data.comparison}"</p>
                                </div>
                            </div>

                            {/* Mock Screenshot/Visual */}
                            <div className="bg-gradient-to-br from-indigo-500/10 to-purple-500/10 rounded-2xl p-2 border border-white/10">
                                <div className="bg-slate-950 rounded-xl p-6 h-[300px] flex items-center justify-center border border-white/5">
                                    <span className="text-slate-500">
                                        [Dynamic Visual for {slug}]
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    )
}
